<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("weekends") }}
      </div>
      <div>
        <router-link class="btn-blue" to="weekends"
          >{{ $t("weekends") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isDisable"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="``" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{
                msgcinema
              }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row">
          <b-form-checkbox
            v-for="(weekdaysLoop, weekdaysKey) in weekDays"
            :key="weekdaysKey"
            class="j-checkbox mr-3 mb-3"
            @change="OnSelectWeekends($event, weekdaysKey)"
            v-model="weekDays[weekdaysKey]"
          >
            <div class="text-capitalize">{{ weekdaysKey }}</div>
          </b-form-checkbox>
        </div>
        <p class="error_message">
          <span v-if="submitted">{{ msgweek }}</span>
        </p>
      </div>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="row">
          <div class="col-md-3 col-xl-2 d-flex align-items-center">
            <label>{{ $t("active") }}</label>
            <b-form-checkbox
              class="j-checkbox ml-4 mb-2"
                v-model="isActive"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
          </div>
          <div class="col-md-9 col-xl-10">
            <div class="col-4">
              <!-- <b-form-checkbox
              class="j-checkbox mr-3 mb-3"
                v-model="isActive"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox> -->
            </div>
          </div>
        </div>
        <p class="error_message">
          <span></span>
        </p>
      </div>

      <div class="col-md-12 text-center mt-4">
        <button
          :disabled="btenable"
          @click.prevent.stop="OnSubmit()"
          class="btn-blue"
        >
          {{ $t("update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      CinemasListCopy: [],
      searchCinema: "",
      btenable: false,
      isDisable: true,
      submitted: false,
      msgcinema: "",
      selectedCinema: "",
      cineid: "",
      CinemasList: [],
      weekDays: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
      isActive: "",
    };
  },
  beforeMount() {
    const { c_id } = this.$route.query;
    if (c_id) {
      this.getAllActiveCinemas(c_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.CinemasList = this.CinemasListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    ResetForm: function () {
      this.weekDays = {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      };
      this.selectedCinema = "";
    },
    getAllActiveCinemas: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;
            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                // this.iscindeID = false;
                this.onSelectCinema(event, cinema);
                // this.getWeekendList(x.cine_id);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },

    onSelectCinema: function (event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cineid = cinema.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
      this.getWeekendList(cinema.cine_id);
    },

    getWeekendList: function (cine_id) {
      MasterService.GetWeekendsList(cine_id).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            let datarecords = data.Records[0];

            this.weekDays.sunday =
              datarecords.week_end_sunday == "Y" ? true : false;
            this.weekDays.monday =
              datarecords.week_end_monday == "Y" ? true : false;
            this.weekDays.tuesday =
              datarecords.week_end_tuesday == "Y" ? true : false;
            this.weekDays.wednesday =
              datarecords.week_end_wednesday == "Y" ? true : false;
            this.weekDays.thursday =
              datarecords.week_end_thurday == "Y" ? true : false;
            this.weekDays.friday =
              datarecords.week_end_friday == "Y" ? true : false;
            this.weekDays.saturday =
              datarecords.week_end_saturday == "Y" ? true : false;

            this.isActive = datarecords.wes_is_active;
          }
        } else {
          this.$toasted.show(data.message);
        }
      });
    },

    OnSelectWeekends: function (event, days) {
      this.weekDays;
      this.msgweek = "";
    },

    OnSubmit: function () {
      this.submitted = true;
      let weekarr = Object.keys(this.weekDays).filter((x) => this.weekDays[x]);

      this.$validator.validate().then((valid) => {
        if (weekarr.length === 0) {
          return (this.msgweek = "Please Select at least One Weekend Day.");
        } else {
          this.btenable = true;
          let payload = {
            cine: this.cineid,
            weekday: this.weekDays,
            active: this.isActive,
          };
          // console.log("payload :", payload);
          MasterService.EditWeekends(payload)
            .then((response) => {
              this.btenable = false;
              console.log("response :", response);
              const { data } = response;

              if (data.status) {
                this.ResetForm();
                this.$router.push({
                  path: "/cinema-manager/weekends",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/WeekendsComponents/editWeekends.vue